/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import React, { Component } from "react";
import PropTypes from "prop-types";
import { discovery } from "dc-core";
import ContextMenuCss from "./css/ContextMenu.css";

class PremiumIndicator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      premiumIndicator: null,
      tooltip: props.tooltip
    };
  }

  async componentDidMount() {
    try {
      const component = await discovery.loadDropinClass("premium-indicator");
      this.setState({ premiumIndicator: component });
    } catch (error) {
      console.error("Failed to load premium indicator:", error);
    }
  }

  render() {
    const { premiumIndicator } = this.state;

    if (!premiumIndicator) {
      return null;
    }

    const PremiumIcon = premiumIndicator;
    return (
      <PremiumIcon
        analyticsSubcategory="mv-context-menu-items"
        classNames={ContextMenuCss.contextMenuItemIcon}
        renderWithTooltip
        tooltipMessage={this.state.tooltip}
        iconSize={12}
      />
    );
  }
}

PremiumIndicator.propTypes = {
  tooltip: PropTypes.string
};

PremiumIndicator.defaultProps = {
  tooltip: ""
};

export default PremiumIndicator;
